import ValidatableObject from "../validation/ValidatableObject";
import Model from "../Model";
import { IRelativeWorkingInCourt } from "./applicantdata/RelativeWorkingInCourt";
import { IAdditionalIncome } from "./applicantdata/AdditionalIncome";
import { INonPaidActivity } from "./applicantdata/NonPaidActivity";
import { IGiftAndDonation } from "./applicantdata/GiftAndDonation";
import { IDebtObligation } from "./applicantdata/DebtObligation";

export interface TReport8Applicant {
  id: number;
  partyId: number;
  name: string;
  lastName: string;
}
export interface IReport8Applicant extends TReport8Applicant {
  relativesWorkingInCourt?: IRelativeWorkingInCourt[];
  additionalIncome?: IAdditionalIncome[];
  nonPaidActivities?: INonPaidActivity[];
  giftsAndDonations?: IGiftAndDonation[];
  debtObligations?: IDebtObligation[];
  fullName: string;
}

const Report8Applicant = Model(
  (model: TReport8Applicant): IReport8Applicant => {
    const _report8Applicant: TReport8Applicant = Object.assign({}, model);

    let create = (report8Applicant: IReport8Applicant): IReport8Applicant => {
      let obj = ValidatableObject(report8Applicant);
      return obj;
    };
    let _relativesWorkingInCourt: IRelativeWorkingInCourt[] = [];
    let _additionalIncome: IAdditionalIncome[] = [];
    let _nonPaidActivities: INonPaidActivity[] = [];
    let _giftsAndDonations: IGiftAndDonation[] = [];
    let _debtObligations: IDebtObligation[] = [];

    let report8Applicant = {
      get id() {
        return _report8Applicant.id;
      },
      set id(value) {
        _report8Applicant.id = value;
      },
      get partyId() {
        return _report8Applicant.partyId;
      },
      set partyId(value) {
        _report8Applicant.partyId = value;
      },
      get name() {
        return _report8Applicant.name;
      },
      set name(value) {
        _report8Applicant.name = value;
      },
      get lastName() {
        return _report8Applicant.lastName;
      },
      set lastName(value) {
        _report8Applicant.lastName = value;
      },
      get additionalIncome() {
        return _additionalIncome;
      },
      set additionalIncome(value) {
        _additionalIncome = value;
      },
      get nonPaidActivities() {
        return _nonPaidActivities;
      },
      set nonPaidActivities(value) {
        _nonPaidActivities = value;
      },
      get relativesWorkingInCourt() {
        return _relativesWorkingInCourt;
      },
      set relativesWorkingInCourt(value) {
        _relativesWorkingInCourt = value;
      },
      get giftsAndDonations() {
        return _giftsAndDonations;
      },
      set giftsAndDonations(value) {
        _giftsAndDonations = value;
      },
      get debtObligations() {
        return _debtObligations;
      },
      set debtObligations(value) {
        _debtObligations = value;
      },
      get fullName() {
        return `${this.name} ${this.lastName}`;
      }
    };
    return create(report8Applicant);
  }
);

export default Report8Applicant;
